import React, { useState } from 'react';
import ImageIcon from '@material-ui/icons/Image';
import './Style.css';
import { LabeledInput, SelectInput } from '../../../Components';
import { ProductLibraryTable } from '../../index';
import Desgin from '../../../Assets/Photos/tshirt.png';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { useHistory } from 'react-router-dom';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
const Index = () => {
    const [productname, setName] = useState('');
    // const [sku, setSKU] = useState('');
    const [rowPerPage, setRowPerPage] = useState(10);

    const hist = useHistory();
    // const [page,setPage] = useState(1);
    return (
        <div className="product_library">
            <div className="product_library_head">
                <h2>Product Library</h2>
                <div className="product_library_head_right">
                    {/* <button style={{ marginRight: '2rem' }} className="btn-gray">
                        Download
                    </button> */}
                    <button
                        onClick={() => {
                            hist.push('/main/addProduct');
                        }}
                        className="btn-orange"
                    >
                        <ImageIcon className="btn-icon" />
                        <p>Add Product</p>
                    </button>
                </div>
            </div>
            <div className="product_libraru_mid">
                <LabeledInput
                    name="product name"
                    value={productname}
                    changeHandler={(e) => {
                        setName(e.target.value);
                    }}
                    label={'Product Name'}
                />
                {/* <LabeledInput
                    name="sku"
                    value={sku}
                    changeHandler={(e) => {
                        setSKU(e.target.value);
                    }}
                    label={'SKU'}
                /> */}
                {/* <CheckBox name="invertory" labeling="Show inventory products" checked={true} /> */}

                <div className="product_libraru_mid_right" style={{ display: 'flex' }}>
                    {/* <button style={{ marginRight: '2rem' }} className="btn-gray">
                        Reset
                    </button> */}
                    <button className="btn-orange">
                        <p>Search</p>
                    </button>
                </div>
            </div>
            <ProductLibraryTable design={Desgin} />
            <div className="pagination_footer">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SelectInput
                        marginZero
                        style={{ minWidth: '30px' }}
                        label="Rows per page:"
                        value={rowPerPage}
                        changeHandler={(e) => {
                            setRowPerPage(e.target.value);
                        }}
                        options={[
                            { name: '10', value: 10 },
                            { name: '25', value: 25 },
                            { name: '50', value: 50 },
                        ]}
                    />
                </div>
                <p className="page_details">1-5 of 5</p>
                <div>
                    <ChevronLeftIcon className={`footer_pagination_icon disabled`} />
                    <ChevronRightIcon className={`footer_pagination_icon`} />
                </div>
            </div>
        </div>
    );
};

export default Index;
